import {
  Box,
  type BoxProps,
  Chip,
  type SelectProps,
  chipClasses,
  styled,
} from "@mui/material"
import type { ReferentialCode, ReferentialValue } from "../../../../types"

// Override values by accessing entity referential
// Override colors by accessing theme colors
export const DEFAULT_OPTIONS = [
  { label: "Actif", value: "ACTIVE", color: "success.main" },
  { label: "Inactif", value: "INACTIVE", color: "error.main" },
]

type Option = (ReferentialCode<string> | ReferentialValue<string>) & {
  color: BoxProps["bgcolor"]
  borderColor?: BoxProps["borderColor"]
}
export type ListItemStateProps = {
  value: string
  options?: Option[]
} & SelectProps

export const ListItemState = ({
  value,
  options = DEFAULT_OPTIONS,
}: ListItemStateProps) => {
  const optionSelected = value
    ? options.find((option) =>
        "code" in option ? option.code === value : option.value === value,
      )
    : options[0]
  if (!optionSelected) return null
  return (
    <ItemStateChip
      variant="outlined"
      label={
        <>
          <Dot
            bgcolor={optionSelected.color}
            sx={{
              borderColor: optionSelected.borderColor ?? optionSelected.color,
            }}
          />
          {upperFirst(optionSelected.label)}
        </>
      }
    />
  )
}

const Dot = styled(Box)({
  display: "inline-block",
  minWidth: "8px",
  height: "8px",
  marginRight: "7px",
  borderRadius: "50%",
  border: "1px solid",
})

const ItemStateChip = styled(Chip)(({ theme }) => ({
  padding: `${theme.spacing(0.6)} ${theme.spacing(1)}`,
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  fontSize: theme.typography.pxToRem(12),
  height: "unset",
  minWidth: 64,
  borderRadius: 100,
  maxWidth: "unset",
  [`& .${chipClasses.label}`]: {
    padding: 0,
    lineHeight: "15px",
    display: "grid",
    gridTemplateColumns: "auto auto",
    alignItems: "center",
    whiteSpace: "break-spaces",
  },
}))

// Azy nik CSS 🖕
const upperFirst = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
